
const Close = () =>{
    return(
        <>
            <h1>Registrations are closed</h1>
        </>
    )
}
export default Close;